<template>
  <div class="container">
    <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/jxb/jxb_bg.jpg" alt="" class="img" />
    <div class="input-container">
        <div class="input-box">
            <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/jxb/phone.png" alt="">
            <span>手机号</span></span>
            <input type="text" maxlength="15" placeholder="(请输入您的手机号,仅开课使用,已加密)" v-model="formData.mobile">
        </div>
         <div class="input-box">
            <img src="https://zk-web-source.oss-cn-beijing.aliyuncs.com/jxb/lock.png" alt="">
            <span>验证码</span>
            <input type="text" maxlength="15" placeholder="(请输入验证码)" v-model="formData.msg">
            <div class="code" @click="sendMsg">获取验证码<span v-if="codeTime != 60" >({{ codeTime}})</span></div>
        </div>
        <div class="subjects">
            <span>选择科目:</span>
            <div class="items">
            <el-checkbox-group v-model="checkSubjects">
              <template v-for="(item,index) in subjectList">
                  <el-checkbox :label="item.name">{{item.name}}
                      <template v-if="index !=2 && index !=5">/</template>
                  </el-checkbox>
                  <br v-if="index == 2"/>
              </template>
            </el-checkbox-group>
            </div>
        </div>
        <div class="submit" @click="onsubmit">立即领课</div>
    </div>
  </div>
</template>

<script>
import { enrollPwd ,sendMsg} from '@/api/index'
import md5 from 'js-md5'
import { phoneValidator } from '@/utils'
export default {
    data(){
        return {
            codeTime: 60,
            formData: {
                mobile: '',
                msg: ''
            },
            checkSubjects:[],
            subjectList:[{
                name:'数学1',
                worthid:'6e78f0a64e064a848a1d31e605872f06',
                subjectid:'590a9a669c3a43c28e220e5ada96c1d6'
            },{
                name:'数学2',
                worthid:'41d8ef16a8ed47d1b6155b6ccd6d8dea',
                subjectid:'313a17e64fc247ccba5903c501b1374c'
            },
            {
                name:'数学3',
                worthid:'286b823695f34dcfbe7f09b11d654156',
                subjectid:'c34d41daed3d4eccbddef17ea4121258'
            },
            {
                name:'英语1',
                worthid:'53e69a09dce7416696b5ffac62f228ee',
                subjectid:'5dcb61ee913b4d3b938f5ecd9d265385'
            },
            {
                name:'英语2',
                worthid:'6acec9d928b04f108628450897d0e049',
                subjectid:'2a7f4192442a4fbebdf77df45f171dde'
            },
            {
                name:'政治',
                worthid:'8e0684128e834382ba9c83671f7c7ba1',
                subjectid:'851bdea6930844e6926159dd2810d8c1'
            }]

        }
    },
    methods:{
        sendMsg() {
            if (!this.formData.mobile) {
                this.$toast.center('请输入手机号');
                return
            }
            if (!phoneValidator(this.formData.mobile)) {
                this.$toast.center('手机号格式错误');
                return
            }
            sendMsg({
                phone: this.formData.mobile,
                type: 1,
                corpId: '123456789'
            }).then(res => {
                this.setCodeTime();
            })
        },
        setCodeTime() {
            const copy = this.codeTime;
            const interval = setInterval(() => {
                let codeTime = this.codeTime - 1;
                if (this.codeTime === 0) {
                    clearInterval(interval);
                    codeTime = copy;
                }
                this.codeTime = codeTime;
            }, 1000)
        },
        onsubmit() {
             if (!this.formData.mobile) {
                this.$toast.center('请输入手机号');
                return
            }
            if (!phoneValidator(this.formData.mobile)) {
                this.$toast.center('手机号格式错误');
                return
            }
           if(!this.checkSubjects.length){
               return this.$toast.center('请选择科目');
           }
           let paramSubjectList = []
           this.subjectList.forEach(item => {
               if(this.checkSubjects.indexOf(item.name) !=-1){
                   paramSubjectList.push(item)
               }
           })
            const gt = new Date().getTime().toString();
            enrollPwd({
                time: gt,
                encryPwd: md5(gt + 'verify'),
                ...this.formData,
                classid:'BK202305080001',
                subjectid:paramSubjectList.map(item => item.subjectid).join(','),
                worthid:paramSubjectList.map(item => item.worthid).join(','),
                collegeName: '考研网课',
                orign: '三味图书',
                promotedAccount: '三味图书-考研',
            }).then(res => {
                this.$toast.center('提交成功')
                this.formData.mobile = ''
                this.formData.msg = ''
                this.checkSubjects = []
            })
        },
    }
}
</script>
<style>
body {
  min-width: 100%;
}
</style>
<style lang="scss" scoped>
.container {
    display: flex;
    justify-content: center;
  position: relative;
  width: 100vw;
  padding-top: 138vw;
  &::-webkit-scrollbar {
    display: none;
  }
  .img {
    position: absolute;
    width: 100vw;
    top: 0;
    vertical-align: bottom;
    z-index: 0;
  }
  .input-container {
    position: relative;
    height: 53vw;
    width: 100%;
    padding:0 5.5vw;
    z-index: 1;
    .input-box{
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        img{
            width: 28px;
            height: 25px;
        }
        span{
            padding-left: 2px;
           padding-right: 5px;
           font-size: 14px;
           color: #060606;
           font-weight: bold;
        }
        input{
            flex: 1;
            border: none;
            outline: none;
            background: #fff;
            padding-left: 10px;
            border: 1px solid #f1f8ff;
            border-radius: 4px;
            box-shadow:  2px 2px 5px rgba(0, 0, 0, 0.18);
            height: 34px;
            font-size: 12px;
         }
         .code{
             display: flex;
             justify-content: center;
             align-items:center;
             width: 100px;
             height: 34px;
             margin-left: 10px;
             color: #fff;

             font-size: 12px;
             border-radius: 10px;
             background: #1787E0;
             span{
                 color: #fff;
             }
         }
    }
    .subjects{
        display: flex;
        color: #4B4B4B;
        font-weight: bold;
        padding-top: 5px;
        padding-left: 30px;
        span{
            flex-shrink: 0;
            padding-right: 5px;
            font-size: 14px;
        }
        .el-checkbox{
            margin-right: 5px;
            margin-bottom: 5px;
            &.is-checked{
                color: #4B4B4B;;
            }
            ::v-deep .el-checkbox__label{
                padding-left: 5px;
                font-size: 14px;
            }
        }
    }
    .submit{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 128px;
        height: 33px;
        font-weight: bold;
        margin: 2px  auto 0;
        background: #1787E0;
        color: #fff;
        font-size: 14px;
        border-radius: 2px;

    }
  }
}
</style>
